import { partyName } from './party'

export * from './date-utilities'
export * from './error-responses'
export * from './file-helper'
export * from './legal-case'
export * from './party'
export * from './string-utilities'
export * from './validation-rules'

/** FIELD DISPLAYS */
export const aNumberFormatDisplay = value => {
  // if all digits and exactly 9 digits, add hyphens for display.
  if (/^[\d]{9}$/.test(value)) return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6)

  // since '*' is no longer stored for A#s, return the value
  return value
}

export const ssnFormatDisplay = value => {
  if (!/^[\d]{9}$/.test(value)) return value

  return value.substring(0, 3) + '-' + value.substring(3, 5) + '-' + value.substring(5)
}

/** SORTING */
export const sortCases = (a, b) => {
  if (
    (!a.closed && b.closed) ||
    (!a.closed && !b.closed && a.last_event_date > b.last_event_date) ||
    (a.closed && b.closed && a.last_event_date > b.last_event_date)
  ) return -1

  if (
    (a.closed && !b.closed) ||
    (!a.closed && !b.closed && a.last_event_date < b.last_event_date) ||
    (a.closed && b.closed && a.last_event_date < b.last_event_date)
  ) return 1

  return 0
}

export const sortByKey = (array, key) => {
  return array.sort(function (a, b) {
    const x = a[key]
    const y = b[key]
    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

export const sortByKeyCaseInsensitive = (array, key) => {
  return array.sort(function (a, b) {
    const x = (a[key] || '').toUpperCase()
    const y = (b[key] || '').toUpperCase()
    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

export const sortByCaseInsensitive = array => {
  return array.sort(function (a, b) {
    const x = (a || '').toUpperCase()
    const y = (b || '').toUpperCase()
    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

/** MISC */
export const goTo = (url, route, router) => {
  if (route.path !== url) router.push(url)
}

export const formatSize = bytes => {
  if (Math.abs(bytes) < 1024) return `${bytes} B`

  const units = ['kB', 'MB']
  let u = -1

  do {
    bytes /= 1024
    ++u
  } while (Math.round(Math.abs(bytes) * 10) / 10 >= 1024 && u < units.length - 1)

  return `${bytes.toFixed(1)} ${units[u]}`
}

export const runRequestsInSequence = (arr, input) => {
  return arr.reduce(
    (promiseChain, currentFunction) => promiseChain.then(currentFunction),
    Promise.resolve(input)
  )
}

/** REGEX Patterns */
export const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const monthPattern = /^(0[1-9]|1[012])$/
export const dayPattern = /^(3[01]|[12][0-9]|0?[1-9])$/

export const dataURIToBlob = dataURI => {
  dataURI = dataURI.replace(/^data:/, '')

  const type = dataURI.match(/image\/[^;]+/)
  const base64 = dataURI.replace(/^[^,]+,/, '')
  const arrayBuffer = new ArrayBuffer(base64.length)
  const typedArray = new Uint8Array(arrayBuffer)

  for (let i = 0; i < base64.length; i++) typedArray[i] = base64.charCodeAt(i)

  return new Blob([arrayBuffer], { type })
}

export const downloadURI = (uri, name) => {
  const link = document.createElement('a')
  link.download = name
  link.href = uri

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const recordPartyName = (record, recordHolder) => {
  return `${record.public_id} - ${partyName(recordHolder)}`
}

export const isValidDay = day => dayPattern.test(day.trim())
export const isValidMonth = month => monthPattern.test(month.trim())

export const deleteReturn = (object, key) => {
  let t

  return (t = object[key]) && delete object[key] && t
}
